export default "__VITE_ASSET__Cw8vkQhn__"